import { render, staticRenderFns } from "./DetailedTrade.vue?vue&type=template&id=4eb628c4&scoped=true&"
import script from "./DetailedTrade.vue?vue&type=script&lang=ts&"
export * from "./DetailedTrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb628c4",
  null
  
)

export default component.exports